export default function() {
	$(document).on('click', '.js-filter-disable-varchar', function(){
		const $this = $(this);
		resetVarcharParam($this.attr('data-code'), $this.attr('data-value'));
	});
	$(document).on('click', '.js-filter-disable-double', function(){
		resetDoubleParam($(this).attr('data-code'));
	});
	$(document).on('click', '.js-filter-disable-price', function(){
		resetPriceParam();
	});
	$(document).on('click', '.js-filter-disable-price', function(){
		resetPriceParam();
	});
	$(document).on('click', '.js-filter-reset', function(){
		resetAll();
	});

	function resetPriceParam() {
		const selector = `input[name="price_min"], input[name="price_max"]`;
		const inputs = $(selector);

		inputs.each(function(){
			$(this).val('').trigger('change');
		});
	}
	function resetDoubleParam(code) {
		const selector = `input[name="${code}[min]"], input[name="${code}[max]"]`;
		const inputs = $(selector);

		inputs.each(function(){
			$(this).val('').trigger('change');
		});
	}
	function resetVarcharParam(code, value) {
		const $filterBlock = $('.filter[data-code="'+code+'"]');

		let selector = '.filter__reset-value[data-value="'+value+'"]';
		const $resetBtn = $filterBlock.find(selector);
		if ($resetBtn.length > 0) {
			$resetBtn.trigger('click');
		} else {
			selector = `input[name="${code}"][value="${value}"]`;
			const inputs = $filterBlock.find(selector);

			inputs.each(function () {
				$(this).prop('checked', false).trigger('change');
			});
		}
	}
	function resetAll() {
		const filtersForm = $('.filters__form');
		const inputs = filtersForm.find('input');
		inputs.each(function(){
			const input = $(this);
			if (input.attr('type') === 'checkbox') {
				input.prop('checked', false);
			} else {
				input.val('').trigger('input');
			}
		});
		setTimeout(function(){
			filtersForm.submit();
		}, 1);
	}
}
